export enum Rates {
	KILOGRAM = 'KILOGRAM',
	POUND = 'POUND',
	PALLET = 'PALLET',
	METRIC_TON = 'Metric Ton',
	BULB = 'BULB',
	GALLONS = 'GALLONS',
	TON = 'TON',
	LITER = 'Liter',
	TROY_OZ = 'TROY OZ',
	GROSS_TON = 'GROSS TON'
}

export declare namespace UnitOfMeasure {
	interface Rate {
		fromUnit: Entity<Rates>
		toUnit: Entity<Rates>
		rate: number
	}
}
